import { mapActions } from "vuex";
import { logIn, logOut } from "@/services/auth";

export default {
  methods: {
    ...mapActions({
      setAccessToken: "Auth/setAccessToken",
      setRefreshToken: "Auth/setRefreshToken",
      setLoggedInUser: "Auth/setLoggedInUser",
      clearState: "Auth/logOut",
    }),
    async globalLogin(credentials, errorCallback = () => {}) {
      try {
        const response = await logIn(credentials);
        await this.setLoginInfo(response);

        const { query } = this.$router.currentRoute;
        this.$router.push(query.redirect ? query.redirect : "/");
      } catch (error) {
        this.$eventBus.$emit("notification", {
          type: "error",
          message: this.$t("login.alert.could-not-login"),
        });

        errorCallback();
      }
    },
    async setLoginInfo(response) {
      let { authToken, username, isClient } = response;

      await this.setAccessToken(authToken.accessToken);
      await this.setRefreshToken(authToken.refreshToken);

      this.setLoggedInUser({
        username,
        cl: isClient,
      });
    },
    async globalLogOut(finalCallback = () => {}) {
      try {
        await logOut();
      } catch {
        return;
      } finally {
        this.clearState();
        finalCallback();
      }
    },
  },
};
